import { TablePagination } from '@mui/material';
import React from 'react';

type SGSTablePaginationProps = {
    count: number;
    page: number;
    rowsPerPage: number;
    onPageChange: (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => void;
    onRowsPerPageChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    color?: string; // Color prop to customize arrow and text color
};

const SGSTablePagination: React.FC<SGSTablePaginationProps> = ({
    count,
    page,
    rowsPerPage,
    onPageChange,
    onRowsPerPageChange,
    color = 'rgb(51, 153, 219)', // Default color
}) => {
    return (
        <TablePagination
            component="div"
            count={count}
            page={page}
            onPageChange={onPageChange}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={onRowsPerPageChange}
            labelRowsPerPage="" // Hides the label
            rowsPerPageOptions={[]} // Removes the dropdown
            labelDisplayedRows={({ from, to, count }) => `Affichage ${from} à ${to} sur ${count !== -1 ? count : `plus de ${to}`}`}
            sx={{
                '& .MuiTablePagination-actions': {
                    '& .MuiIconButton-root': {
                        color: color, // Use the color prop
                        '&:hover': {
                            backgroundColor: `${color}1A`, // Add transparency for hover effect
                        },
                    },
                },
                '& .MuiTablePagination-displayedRows': {
                    margin: 0,
                    padding: 0,
                    display: 'flex',
                    alignItems: 'center',
                    fontFamily: 'Open Sans',
                    fontStyle: 'normal',
                    fontSize: '0.85rem',
                    color: color, // Use the color prop
                    fontWeight: 700,
                },
            }}
        />
    );
};

export default SGSTablePagination;
